(function () {
  'use strict';

  function replaceWithButton(element, label) {
    if (!element || element.tagName === 'BUTTON') return element;

    var button = document.createElement('button');
    Array.prototype.forEach.call(element.attributes, function (attribute) {
      if (attribute.name !== 'href' && attribute.name !== 'rel') {
        button.setAttribute(attribute.name, attribute.value);
      }
    });
    button.type = 'button';
    button.innerHTML = element.innerHTML;
    if (label && !button.getAttribute('aria-label')) {
      button.setAttribute('aria-label', label);
    }
    element.replaceWith(button);
    return button;
  }

  function prepareMiniCart(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.cart__mini-qty--minus[href="#"]').forEach(function (control) {
      replaceWithButton(control, 'Réduire la quantité');
    });
    scope.querySelectorAll('.cart__mini-qty--plus[href="#"]').forEach(function (control) {
      replaceWithButton(control, 'Augmenter la quantité');
    });
    scope.querySelectorAll('.remove-from-cart[href="#"]').forEach(function (control) {
      replaceWithButton(control, 'Supprimer cet article du panier');
    });

    if (!window.theme || !window.theme.terms_conditions_enable || !window.theme.terms_url) return;

    scope.querySelectorAll('#checkout__canvas').forEach(function (checkbox) {
      checkbox.required = true;
      checkbox.classList.remove('hide');
      checkbox.classList.add('nimbli-visually-hidden');

      var label = checkbox.parentElement.querySelector('label[for="' + checkbox.id + '"]');
      if (!label || label.dataset.nimbliTermsReady === 'true') return;

      label.dataset.nimbliTermsReady = 'true';
      label.classList.add('nimbli-terms-consent');
      var text = label.querySelector('.label__text');
      if (text) {
        text.textContent = 'J’accepte les ';
        var link = document.createElement('a');
        link.href = window.theme.terms_url;
        link.textContent = 'conditions générales de vente';
        text.appendChild(link);
        text.appendChild(document.createTextNode('.'));
      }
    });
  }

  function getFocusableElements(panel) {
    if (!panel) return [];

    return Array.prototype.filter.call(
      panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ),
      function (element) {
        return !element.hidden && element.getAttribute('aria-hidden') !== 'true';
      }
    );
  }

  function bindAccessiblePanel(options) {
    var panel = document.querySelector(options.panelSelector);
    var controls = Array.prototype.slice.call(document.querySelectorAll(options.controlSelector));
    if (!panel || !controls.length) return;

    var wasOpen = panel.classList.contains(options.openClass);
    var lastTrigger = null;

    function isOpen() {
      return panel.classList.contains(options.openClass);
    }

    function sync() {
      var open = isOpen();
      var openedNow = open && !wasOpen;
      var closedNow = !open && wasOpen;

      if (openedNow && (!lastTrigger || !document.documentElement.contains(lastTrigger))) {
        var activeElement = document.activeElement;
        if (activeElement && activeElement !== document.body && !panel.contains(activeElement)) {
          lastTrigger = activeElement;
        }
      }

      controls.forEach(function (control) {
        control.setAttribute('aria-expanded', String(open));
      });

      if (closedNow && panel.contains(document.activeElement)) {
        var returnTarget = lastTrigger ||
          document.querySelector(options.returnFocusSelector || options.controlSelector);
        if (returnTarget) returnTarget.focus();
      }

      panel.setAttribute('aria-hidden', String(!open));
      if (open) {
        panel.removeAttribute('inert');
      } else {
        panel.setAttribute('inert', '');
      }

      if (openedNow) {
        window.requestAnimationFrame(function () {
          var focusTarget = panel.querySelector(options.initialFocusSelector);
          if (!focusTarget) focusTarget = getFocusableElements(panel)[0] || panel;
          focusTarget.focus();
        });
      }

      wasOpen = open;
      if (closedNow) lastTrigger = null;
    }

    controls.forEach(function (control) {
      control.addEventListener('click', function () {
        lastTrigger = control;
        window.requestAnimationFrame(sync);
      });
    });

    panel.addEventListener('keydown', function (event) {
      if (!isOpen()) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        options.close(panel, lastTrigger);
        window.requestAnimationFrame(sync);
        return;
      }

      if (event.key !== 'Tab') return;
      var focusable = getFocusableElements(panel);
      if (!focusable.length) {
        event.preventDefault();
        panel.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    var observer = new MutationObserver(sync);
    observer.observe(panel, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  function prepareAccessiblePanels() {
    bindAccessiblePanel({
      panelSelector: '#desktop_cart',
      controlSelector: '.site-header__cart[aria-controls="desktop_cart"]',
      returnFocusSelector: '.site-header__cart[aria-controls="desktop_cart"]',
      openClass: 'active',
      initialFocusSelector: '.close_cart',
      close: function (panel) {
        var closeButton = panel.querySelector('.close_cart');
        if (closeButton) closeButton.click();
      }
    });

    bindAccessiblePanel({
      panelSelector: '#mobile_menu',
      controlSelector: '#show-megamenu[aria-controls="mobile_menu"], .site-nav--btn[aria-controls="mobile_menu"]',
      returnFocusSelector: '#show-megamenu[aria-controls="mobile_menu"], .site-nav--btn[aria-controls="mobile_menu"]',
      openClass: 'act',
      initialFocusSelector: 'a[href], button:not([disabled])',
      close: function (panel, trigger) {
        var control = trigger ||
          document.querySelector('#show-megamenu[aria-controls="mobile_menu"], .site-nav--btn[aria-controls="mobile_menu"]');
        if (control) {
          control.click();
        } else {
          panel.classList.remove('act');
        }
      }
    });

    bindAccessiblePanel({
      panelSelector: '#mobile_search',
      controlSelector: '.mobile-btn_search[aria-controls="mobile_search"]',
      openClass: 'act',
      initialFocusSelector: 'input:not([disabled])',
      close: function (panel, trigger) {
        if (trigger) trigger.click();
      }
    });

    bindAccessiblePanel({
      panelSelector: '#NimbliSearchCanvas',
      controlSelector: '.search__btn-overlay[aria-controls="NimbliSearchCanvas"]',
      openClass: 'act',
      initialFocusSelector: 'input:not([disabled])',
      close: function (panel, trigger) {
        if (trigger) trigger.click();
      }
    });
  }

  function prepareProductNavigationDisclosures() {
    document.querySelectorAll('.nimbli-nav-products__disclosure').forEach(function (disclosure) {
      var summary = disclosure.querySelector('.nimbli-nav-products__summary');
      if (!summary || disclosure.dataset.nimbliDisclosureReady === 'true') return;

      function syncExpandedState() {
        summary.setAttribute('aria-expanded', String(disclosure.open));
      }

      disclosure.dataset.nimbliDisclosureReady = 'true';
      disclosure.addEventListener('toggle', syncExpandedState);
      syncExpandedState();
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('#cart-info form')) return;

    var checkbox = form.querySelector('#checkout__canvas[required]');
    if (checkbox && !checkbox.checked) {
      event.preventDefault();
      var label = form.querySelector('label[for="' + checkbox.id + '"]');
      if (label) label.classList.add('nimbli-terms-consent--invalid');
      checkbox.focus();
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.matches('#checkout__canvas')) {
      var label = document.querySelector('label[for="' + event.target.id + '"]');
      if (label) label.classList.remove('nimbli-terms-consent--invalid');
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    prepareMiniCart(document);
    prepareAccessiblePanels();
    prepareProductNavigationDisclosures();

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) prepareMiniCart(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
